import { messages } from '@qality/common-messages';
import { CreateIssueResult, Issue } from '@qality/common-model';
import { FlagService } from '@qality/common-service';

import AP from './AP';

export default {
  createLinkErrorFlag(testCase: Issue): void {
    FlagService.createControlledFlag(
      messages['error.qalityIssueView.createLinkTestCase.header'],
      messages['error.qalityIssueView.createLinkTestCase.body'],
      'error',
      15000,
      { ['testCaseCreatedQAlity_' + testCase.key]: testCase.key }
    );

    AP.events.on('flag.action', function (event) {
      if (event.actionIdentifier.startsWith('testCaseCreatedQAlity_')) {
        const issueKey = event.actionIdentifier.split('_')[1];
        AP.navigator.go('issue', {
          issueKey: issueKey,
        });
      }
    });
  },

  async showCreateIssueDialog(
    summary: string,
    issueTypeId: number,
    projectId: number
  ): Promise<CreateIssueResult> {
    const defaultFields = {
      summary,
    };
    return openCreateIssueDialog(projectId, issueTypeId, defaultFields);
  },

  async showCreateIssueDialogWithDescription(
    summary: string,
    issueTypeId: number,
    projectId: number,
    description: string
  ): Promise<CreateIssueResult> {
    return openCreateIssueDialog(projectId, issueTypeId, {
      summary,
      description,
    });
  },
};

function openCreateIssueDialog(
  projectId: number,
  issueTypeId: number,
  defaultFields: { summary: string; description?: string }
): Promise<CreateIssueResult> {
  return new Promise((resolve) => {
    AP.jira.openCreateIssueDialog(
      (issues) => {
        resolve(issues as CreateIssueResult);
      },
      {
        pid: projectId,
        issueType: issueTypeId,
        fields: defaultFields,
      }
    );
  });
}
